import withOptions from 'utils/functions/withOptions.util';
import isNotDomElement from 'utils/predicates/dom/isNotDomElement.util';
import isNotFn from 'utils/predicates/function/isNotFn.util';

const elementContains = withOptions(({ ancestor, descendant }) => {
  if (isNotDomElement(ancestor)) return false;
  if (isNotDomElement(descendant)) return false;

  if (isNotFn(ancestor.contains)) return false;

  return ancestor.contains(descendant);
});

// noinspection JSUnusedGlobalSymbols
export default elementContains;
